"use client";

import { motion } from "framer-motion";
import { social_link_motion } from "./_config";

interface VideoBannerProps {
  title: string;
  banner: string;
  source: string;
}

export default function VideoBanner({
  title,
  banner,
  source,
}: VideoBannerProps) {

  return (
    <motion.div
      variants={social_link_motion}
      initial="hidden"
      whileInView="visible"
      transition={{
        delay: 0.7 * 0.1,
        type: "spring",
        stiffness: 100,
      }}
      className="relative flex aspect-video rounded-xl overflow-hidden  w-full items-center justify-center lg:w-5/10"
    >
      <video
        controls
        src={source}
        poster={banner}
        className="aspect-video w-full object-cover"
        aria-label={title ?? "Video player"}
      />
    </motion.div>
  );
}
